// management/* page translations
const management = {
  factoryList: {
    label: {
      status: 'Status',
    },
    status: {
      all: 'All',
      normal: 'Normal',
      warning: 'Warning',
      error: 'Error',
    },
    searchPlaceholder: 'Search factory name or code',
    addBtn: 'Add Factory',
    loading: 'Loading data...',
    col: {
      name: 'Factory Name',
      code: 'Code',
      location: 'Location',
      temperature: 'Temperature',
      humidity: 'Humidity',
      equipmentStatus: 'Equipment Status',
      operationRate: 'Operation Rate',
      status: 'Status',
      lastInspection: 'Last Inspection',
      action: 'Action',
    },
    manager: 'Manager: {manager}',
    equipmentTotal: 'Total {total}',
    equipmentRunning: 'Running {running}',
    equipmentIdle: 'Idle {idle}',
    equipmentStopped: 'Stopped {stopped}',
    deleteModal: {
      title: 'Delete Factory',
      message: 'Delete factory "{name}"?\nThis action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
    alertDeleted: 'Factory "{name}" has been deleted.',
    alertDeleteFail: 'Failed to delete factory.',
  },
  factoryRegister: {
    section: {
      basic: 'Basic Information',
      manager: 'Manager Information',
    },
    label: {
      name: 'Factory Name',
      code: 'Factory Code',
      location: 'Location',
      address: 'Detailed Address',
      managerName: 'Manager Name',
      contact: 'Phone',
      email: 'Email',
      description: 'Note',
    },
    placeholder: {
      name: 'Enter factory name',
      code: 'e.g., SEL-001',
      location: 'e.g., Geumcheon-gu, Seoul',
      address: 'Enter detailed address',
      managerName: 'Enter manager name',
      contact: '010-0000-0000',
      email: 'example@company.com',
      description: 'Enter additional description',
    },
    btn: {
      cancel: 'Cancel',
      submit: 'Register Factory',
    },
    alertSuccess: 'Factory has been successfully registered.',
    alertDuplicate: 'Factory code already exists. Please use a different code.',
    alertFail: 'Failed to register factory. Please check your input.',
  },
  factoryDetail: {
    title: 'Factory Details',
    loading: 'Loading data...',
    section: {
      basic: 'Basic Information',
      manager: 'Manager Information',
      operation: 'Operation Information',
      environment: 'Environment Information',
    },
    label: {
      name: 'Factory Name',
      code: 'Factory Code',
      location: 'Location',
      address: 'Detailed Address',
      managerName: 'Manager Name',
      contact: 'Phone',
      email: 'Email',
      totalEquipment: 'Total Equipment',
      running: 'Running',
      idle: 'Idle',
      stopped: 'Stopped',
      status: 'Status',
      description: 'Note',
      temperature: 'Current Temperature',
      humidity: 'Current Humidity',
      totalEquipmentShort: 'Total Equipment',
      operationRate: 'Operation Rate',
      establishedDate: 'Established',
      lastInspection: 'Last Inspection',
    },
    status: {
      normal: 'Normal',
      warning: 'Warning',
      error: 'Error',
    },
    unit: {
      count: '{n}',
    },
    btn: {
      delete: 'Delete',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
    },
    alertLoadFail: 'Failed to load factory information.',
    alertUpdateSuccess: 'Factory information has been successfully updated.',
    alertUpdateFail: 'Failed to update factory information.',
    confirmDelete: 'Are you sure you want to delete this factory?\nDeleted data cannot be recovered.',
    alertDeleteSuccess: 'Factory has been successfully deleted.',
    alertDeleteFail: 'Failed to delete factory.',
  },
  equipmentList: {
    loading: 'Loading data...',
    label: {
      factory: 'Factory',
      line: 'Line',
      status: 'Status',
    },
    statusOption: {
      all: 'All',
      running: 'Running',
      idle: 'Idle',
      maintenance: 'Maintenance',
      fault: 'Fault',
    },
    status: {
      running: 'Running',
      idle: 'Idle',
      stopped: 'Stopped',
      maintenance: 'Maintenance',
      fault: 'Fault',
      offline: 'Offline',
    },
    searchPlaceholder: 'Search equipment name or model',
    addBtn: 'Add Equipment',
    col: {
      name: 'Equipment Name',
      model: 'Model',
      factory: 'Factory',
      line: 'Line',
      manufacturer: 'Manufacturer',
      serialNumber: 'Serial No.',
      status: 'Status',
      maxTemperature: 'Max Temp',
      maxPressure: 'Max Pressure',
      cycleTime: 'Cycle Time',
      cavity: 'Cavity',
      lastInspection: 'Inspection',
      action: 'Action',
    },
    deleteModal: {
      title: 'Delete Equipment',
      message: 'Delete equipment "{name}"?\nThis action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
    alertDeleted: 'Equipment "{name}" has been deleted.',
    alertDeleteFail: 'Failed to delete equipment.',
  },
  equipmentRegister: {
    section: {
      basic: 'Basic Information',
      spec: 'Specifications',
    },
    label: {
      equipmentCode: 'Equipment Code',
      equipmentName: 'Equipment Name',
      model: 'Model',
      factory: 'Factory',
      line: 'Line',
      manufacturer: 'Manufacturer',
      serialNumber: 'Serial Number',
      installDate: 'Installation Date',
      warrantyEndDate: 'Warranty End Date',
      initialStatus: 'Initial Status',
      maxTemperature: 'Max Temperature (°C)',
      maxPressure: 'Max Pressure (MPa)',
      ratedPower: 'Rated Power (kW)',
      targetCycleTime: 'Target Cycle Time (sec)',
      cavityCount: 'Cavity Count',
      lastInspectionDate: 'Last Inspection Date',
      nextMaintenanceDate: 'Next Maintenance Date',
      description: 'Note',
    },
    placeholder: {
      equipmentCode: 'e.g., E001',
      equipmentName: 'e.g., Injection Machine #1',
      model: 'e.g., LS-350H',
      factorySelect: 'Select factory',
      lineSelect: 'Select line (unassigned)',
      manufacturer: 'Enter manufacturer',
      serialNumber: 'Enter equipment serial number',
      maxTemperature: 'e.g., 350',
      maxPressure: 'e.g., 180',
      ratedPower: 'e.g., 35.0',
      targetCycleTime: 'e.g., 45',
      cavityCount: 'e.g., 4',
      description: 'Enter additional description',
    },
    statusOption: {
      running: 'Running',
      idle: 'Idle',
      stopped: 'Stopped',
      maintenance: 'Maintenance',
      fault: 'Fault',
      offline: 'Offline',
    },
    btn: {
      cancel: 'Cancel',
      submit: 'Register Equipment',
    },
    alertSuccess: 'Equipment has been successfully registered.',
    alertDuplicate: 'Equipment code already exists. Please use a different code.',
    alertFail: 'Failed to register equipment. Please check your input.',
  },
  equipmentDetail: {
    title: 'Equipment Details',
    loading: 'Loading data...',
    section: {
      basic: 'Basic Information',
      spec: 'Specifications',
    },
    label: {
      equipmentName: 'Equipment Name',
      equipmentCode: 'Equipment Code',
      model: 'Model',
      factory: 'Factory',
      line: 'Line',
      manufacturer: 'Manufacturer',
      serialNumber: 'Serial Number',
      installDate: 'Installation Date',
      warrantyEndDate: 'Warranty End Date',
      status: 'Status',
      maxTemperature: 'Max Temperature',
      maxPressure: 'Max Pressure',
      ratedPower: 'Rated Power',
      targetCycleTime: 'Target Cycle Time',
      cavityCount: 'Cavity Count',
      lastInspectionDate: 'Last Inspection Date',
      nextMaintenanceDate: 'Next Maintenance Date',
      description: 'Note',
      cavity: 'Cavity',
      targetCycle: 'Target Cycle',
      lastInspection: 'Last Inspection',
    },
    placeholder: {
      lineSelect: 'Unassigned',
    },
    statusOption: {
      running: 'Running',
      idle: 'Idle',
      stopped: 'Stopped',
      maintenance: 'Maintenance',
      fault: 'Fault',
      offline: 'Offline',
    },
    btn: {
      delete: 'Delete',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
    },
    alertLoadFail: 'Failed to load equipment information.',
    alertUpdateSuccess: 'Equipment information has been successfully updated.',
    alertUpdateFail: 'Failed to update equipment information.',
    confirmDelete: 'Are you sure you want to delete this equipment?',
    alertDeleteSuccess: 'Equipment has been successfully deleted.',
    alertDeleteFail: 'Failed to delete equipment.',
  },
  userList: {
    loading: 'Loading data...',
    label: {
      role: 'Role',
    },
    roleOption: {
      all: 'All',
      systemAdmin: 'System Administrator',
      normalUser: 'Regular User',
    },
    role: {
      superAdmin: 'Super Administrator',
      systemAdmin: 'System Administrator',
      normalUser: 'Regular User',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
      locked: 'Locked',
    },
    permissionLabel: {
      dashboard: 'Dashboard',
      monitoring: 'Monitoring',
      factory: 'Factory Mgmt',
      equipment: 'Equipment Mgmt',
      user: 'User Mgmt',
      role: 'Role Mgmt',
      system: 'System Mgmt',
    },
    searchPlaceholder: 'Search by name or email',
    addBtn: 'Add User',
    col: {
      user: 'User',
      position: 'Position',
      department: 'Department',
      status: 'Status',
      lastLogin: 'Last Login',
      joinDate: 'Join Date',
      roleGroup: 'Role Group',
      permissions: 'Permissions',
      action: 'Action',
    },
    deleteModal: {
      title: 'Delete User',
      message: 'Delete user "{name}"?\nThis action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
    alertDeleted: 'User "{name}" has been deleted.',
    alertDeleteFail: 'Failed to delete user.',
  },
  userRegister: {
    section: {
      basic: 'Basic Information',
      organization: 'Organization Information',
      permissions: 'Permissions',
    },
    label: {
      name: 'Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      phone: 'Phone',
      department: 'Department',
      position: 'Position',
      status: 'Account Status',
      roleGroup: 'Role Group',
    },
    placeholder: {
      name: 'Enter user name',
      email: 'example@company.com',
      password: 'Enter password (8+ characters)',
      confirmPassword: 'Re-enter password',
      phone: '010-0000-0000',
      department: 'Enter department name',
      position: 'Enter position',
    },
    statusOption: {
      active: 'Active',
      inactive: 'Inactive',
    },
    permissionsNote: '(Automatically set based on selected role group)',
    permissionsEmpty: 'Select a role group to display permission information.',
    permissionCategoryEtc: 'Other',
    btn: {
      cancel: 'Cancel',
      submit: 'Register User',
    },
    alertPasswordMismatch: 'Passwords do not match.',
    alertSuccess: 'User has been registered.',
    alertFail: 'Failed to register user. Please try again.',
    alertRoleGroupFail: 'Failed to load role group list.',
  },
  userDetail: {
    title: 'User Details',
    loading: 'Loading data...',
    notFound: 'User information not found.',
    section: {
      basic: 'Basic Information',
      organization: 'Organization Information',
      permissions: 'Permissions',
    },
    label: {
      name: 'Name',
      email: 'Email',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      phone: 'Phone',
      department: 'Department',
      position: 'Position',
      status: 'Account Status',
      roleGroup: 'Role Group',
      joinDate: 'Join Date',
      lastLogin: 'Last Login',
    },
    placeholder: {
      newPassword: 'Enter only if changing',
      confirmPassword: 'Re-enter password',
      phone: '010-1234-5678',
      department: 'e.g., Management Support',
      position: 'e.g., Manager',
    },
    statusOption: {
      active: 'Active',
      inactive: 'Inactive',
      locked: 'Locked',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
      locked: 'Locked',
    },
    permissionsNote: ' (Automatically set based on role group)',
    permissionsEmpty: 'No permissions configured.',
    permissionCategoryEtc: 'Other',
    btn: {
      delete: 'Delete',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
    },
    alertPasswordMismatch: 'Passwords do not match.',
    alertLoadFail: 'Failed to load user information.',
    alertUpdateSuccess: 'User information has been updated.',
    alertUpdateFail: 'Failed to update user information.',
    confirmDelete: 'Are you sure you want to delete this user?\nThis action cannot be undone.',
    alertDeleteSuccess: 'User has been deleted.',
    alertDeleteFail: 'Failed to delete user.',
  },
};

export default management;
